import { BaseService } from '../base';
class FeaturesService extends BaseService {
    constructor() {
        super('/settings/features');
    }
}
export default FeaturesService;
